module.exports = __webpack_public_path__ + "static/chat-buble-point-f57aaad1899f1bfccb7d77ff1f212e6e.png";